import React from 'react';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { observer } from 'mobx-react';
import './firstViewForNewKeyVisual.module.scss';
import { V3Routes } from '../../../../routes/index';

type Props = {};

export const FirstViewForSp = () => {
    return (
        <div styleName="first-view-for-ab-test">
            <div styleName="background-image-sp" />
            <a styleName="button_sp" href={V3Routes.trialLessons().pathname} target="_blank" />
        </div>
    );
};

export const FirstViewForPc = () => {
    return (
        <div styleName="first-view-for-ab-test">
            <div styleName="base_background-image-pc" />
            <div styleName="backgraound-image-pc" />
            <a styleName="button_pc" href={V3Routes.trialLessons().pathname} target="_blank" />
        </div>
    );
};

@observer
export class FirstViewForNewKeyVisual extends React.Component<Props> {
    render() {
        const { isSp } = GlobalStatesV3.viewport;
        return isSp ? <FirstViewForSp /> : <FirstViewForPc />;
    }
}
